import { render, staticRenderFns } from "./UserConfigList.vue?vue&type=template&id=5cd2df20&scoped=true"
import script from "./UserConfigList.vue?vue&type=script&lang=js"
export * from "./UserConfigList.vue?vue&type=script&lang=js"
import style0 from "./UserConfigList.vue?vue&type=style&index=0&id=5cd2df20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd2df20",
  null
  
)

export default component.exports